<!--<b>GESTORT KAPITAAL</b><br/>-->
<!--<p>-->
<!--    Het gestort kapitaal is het bedrag dat de aandeelhouders voor hun aandelen hebben betaald aan de BV of NV.-->
<!--    Dit bedrag wordt overgemaakt op de bankrekening van de vennootschap.-->
<!--    Het gestort kapitaal is dus eigenlijk het vermogen dat daadwerkelijk in de BV of NV aanwezig is en tot haar-->
<!--    beschikking heeft.-->
<!--    <br/><br/>-->
<!--    Als de storting op aandelen heeft plaatsgevonden in het kader van een geruisloze omzetting, geldt in principe de-->
<!--    boekwaarde van het vermogen van de ingebrachte onderneming, na aftrek van de fiscale reserves, als gestort kapitaal.-->
<!--    In dat geval stelt u in de fiscale vermogensopstelling het bedrag van het gestorte kapitaal, samen met het eventuele-->
<!--    agio, gelijk aan de fiscale boekwaarde van de overgedragen onderneming op het overgangstijdstip.-->

<!--    Voor een rechtspersoon die geen nv of bv is, vermeld je het equivalent voor het begrip kapitaal dat voor die-->
<!--    rechtspersoon geldt.-->
<!--</p>-->
<!--<br/>-->

<!--<b>INFORMEEL KAPITAAL</b>-->
<!--<p>-->
<!--    Van informeel kapitaal kan sprake zijn als de vennootschap door de aandeelhouder(s) is bevoordeeld, zonder dat een-->
<!--    storting op aandelen heeft plaatsgevonden. De waarde van deze bevoordeling geef je hier aan.-->
<!--</p>-->
<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <p><u>Voorbeeld</u></p>-->
<!--    De aandeelhouder verkoopt onroerend goed aan de vennootschap voor € 500.000, terwijl de werkelijke waarde € 800.000-->
<!--    is. De vennootschap wordt bevoordeeld voor € 300.000.-->
<!--</div>-->
<!--<br/>-->
<!--<p>-->
<!--    Als informele kapitaalstorting wordt ook aangemerkt de kapitaalstorting voor toegekende werknemersopties.-->
<!--</p>-->
<!--<br/>-->

<!--<b>AGIORERSERVE</b>-->
<!--Agio is het bedrag dat bij uitgifte van aandelen wordt gestort boven het nominale bedrag.-->
<!--<br/>-->

<!--<b>WINSTERESERVES</b>-->
<!--<p>-->
<!--    Winstreserves zijn:-->
<!--</p>-->
<!--<ul>-->
<!--    <li>Winsten die in het verleden zijn behaald, maar die niet zijn uitgekeerd.</li>-->
<!--    <li>Verliezen die in het verleden zijn behaald.</li>-->
<!--</ul>-->
<!--<br/>-->

<!--<b>KOSTENEGALISATIERESERVE</b>-->
<!--<p>Je mag een zogenoemde egalisatiereserve vormen voor kosten en lasten van de bedrijfsuitoefening in dit boekjaar, die-->
<!--    pas in de toekomst tot een piek in de uitgaven leiden. Het bekendste voorbeeld hiervan zijn onderhoudskosten aan-->
<!--    gebouwen en schepen, waarbij het daadwerkelijke onderhoud bijvoorbeeld eens in de 10 jaar gebeurt.<br/>-->
<!--    Een belangrijke voorwaarde is dat het gaat om toekomstige uitgaven wegens kosten, en niet om toekomstige aanschaf of-->
<!--    verbetering van bedrijfsmiddelen. De uitgaven voor aanschaf of verbetering van een bedrijfsmiddel brengt u in-->
<!--    mindering op de winst door de jaarlijkse afschrijving op dit bedrijfsmiddel.-->
<!--</p>-->

<!--<p>De overige voorwaarden voor het vormen van de egalisatiereserve zijn in de jurisprudentie ontwikkeld. Deze-->
<!--    zijn:</p>-->
<!--<ul>-->
<!--    <li>De kosten worden verdeeld in de toekomst uitgegeven.</li>-->
<!--    <li>De kosten zijn noodzakelijk geworden door de ondernemingsuitoefening in het jaar van dotatie (toevoeging).</li>-->
<!--    <li>De kosten die in een bepaald jaar zijn opgeroepen, leiden in een komend jaar tot een piek in de uitgaven.</li>-->
<!--    <li>Er is een redelijke mate van zekerheid dat de uitgaven zich zullen voordoen.</li>-->
<!--</ul>-->

<!--<b>Te reserveren bedrag</b>-->
<!--<p>Het bedrag dat je mag reserveren, hangt af van de verwachting over de hoogte van de toekomstige kosten en het-->
<!--    tijdstip waarop u de kosten maakt. Je moet dus een redelijke schatting maken. Blijkt achteraf dat de schatting te-->
<!--    hoog is uitgevallen? Dan moet je het overschot in de winst opnemen. De jaarlijkse toevoeging hoeft niet altijd-->
<!--    gelijk te zijn. Deze kan bijvoorbeeld wijzigen als de kosten stijgen of de periode verandert. De wijzigingen geef je-->
<!--    op bij 'Wijzigingen in toelaatbare reserves'.-->
<!--    <br/>Je mag een aparte reserve vormen per bedrijfsmiddel. Het is ook mogelijk dat je een reserve vormt per object,-->
<!--    bijvoorbeeld voor onderhoud dat eens per 10 jaar en onderhoud dat eens per 15 jaar moet worden verricht. In de-->
<!--    balans vermeld je de boekwaarde van het totaal van de afzonderlijke egalisatiereserves.</p>-->

<!--<b>Afname van de reserve</b>-->
<!--<p>In het jaar waarin de vennootschap de kosten (van bijvoorbeeld het onderhoud) maakt, boek je de kosten af op de-->
<!--    reserve. Als de reserve hoger is dan de gemaakte kosten, dan moet je het restant van de reserve opnemen in de winst.-->
<!--    Zijn de kosten hoger dan de gevormde reserve, dan trek je de hogere kosten in 1 keer af van de winst.<br/>-->
<!--    Je moet de reserve ook in de winst opnemen als het doel waarvoor de reserve ooit is gevormd, is komen te vervallen.-->
<!--    Dit is bijvoorbeeld het geval als de vennootschap het bedrijfsmiddel verkoopt waarvoor ze de reserve had gevormd, of-->
<!--    als het bedrijfsmiddel verloren gaat.-->
<!--</p>-->

<!--<br/>-->

<!--<b>HERINVESTERINGSRESERVE</b>-->
<!--<p>Je mag de boekwinst op bedrijfsmiddelen opnemen in de herinvesteringsreserve. Je hoeft dan niet direct belasting te-->
<!--    betalen over de boekwinst. Voorwaarde is dat de vennootschap op de balansdatum een voornemen hebt om te-->
<!--    herinvesteren in een-->
<!--    bedrijfsmiddel.-->
<!--    <br/>En het moet gaan om bedrijfsmiddelen die de vennootschap heeft ‘vervreemd’. Daarvan is sprake als je een-->
<!--    bedrijfsmiddel verkoopt.-->
<!--    Maar ook als ke een bedrijfsmiddel verliest of als het beschadigd raakt.-->
<!--</p>-->

<!--<b>Bij verkoop van een bedrijfsmiddel</b>-->
<!--<p>De boekwinst op het verkochte bedrijfsmiddel neemt je niet op in de fiscale winst, maar voeg je toe aan de-->
<!--    herinvesteringsreserve. Hiermee voorkom je dat er direct belasting wordt geheven over die boekwinst.-->
<!--</p>-->

<!--<b>Bij verlies of beschadiging van een bedrijfsmiddel</b>-->
<!--<p>Ontvang de vennootschap een vergoeding voor het verlies of de beschadiging? Dan komt die als opbrengst in de-->
<!--    boekhouding te staan.-->
<!--    Het verschil tussen deze opbrengst en de boekwaarde van het bedrijfsmiddel is de boekwinst. Die mag je opnemen-->
<!--    in de herinvesteringsreserve.-->
<!--</p>-->

<!--<b>Afboeken herinvesteringsreserve</b>-->
<!--<p>Gaat de vennootschap herinvesteren? Boek dan de gereserveerde boekwinst als een 1e afboeking op de aanschafprijs van-->
<!--    het aangeschafte bedrijfsmiddel. Door de afboeking mag de boekwaarde van het nieuwe bedrijfsmiddel niet lager worden-->
<!--    dan de boekwaarde van het vervreemde bedrijfsmiddel op het moment van vervreemding. Het restant van de reserve kun-->
<!--    je afboeken op een eventuele volgende investering die de vennootschap binnen de herinvesteringstermijn doet.-->
<!--    <br/>-->
<!--    De afboeking verlaagt de afschrijvingsbasis van het nieuwe bedrijfsmiddel.-->
<!--</p>-->
<!--<div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">-->
<!--    <p><u>Voorbeeld</u></p>-->
<!--    <p>De hoogte van de herinvesteringsreserve is € 5.000. De vennootschap investeert voor € 30.000 in een nieuw-->
<!--        bedrijfsmiddel. De restwaarde van dit bedrijfsmiddel is € 10.000. De afschrijving is 20% per jaar.-->
<!--        <br/>De afschrijving per jaar bedraagt dan:</p>-->
<!--    <ul>-->
<!--        <li>zonder 1e afboeking op de aanschafprijs: 20% van (€ 30.000 - € 10.000) = € 4.000.</li>-->
<!--        <li>met 1e afboeking op de aanschafprijs: 20% van (€ 30.000 - € 5.000 - € 10.000) = € 3.000.</li>-->
<!--    </ul>-->
<!--</div>-->
<!--<br/>-->
<!--<p>Op het verplicht afboeken van de herinvesteringsreserve bestaat een uitzondering. De herinvesteringsreserve die-->
<!--    ontstaat door de vervreemding van een bedrijfsmiddel waarop de vennootschap niet afschrijft of waarop de-->
<!--    vennootschap in meer dan 10 jaar afschrijft, hoef je namelijk pas af te boeken als de vennootschap een-->
<!--    bedrijfsmiddel aanschaft met dezelfde economische functie als het vervreemde bedrijfsmiddel. Je bent bijvoorbeeld-->
<!--    niet verplicht de herinvesteringsreserve van een verkocht bedrijfspand af te boeken op de aanschaffingskosten van-->
<!--    een computer. Maar het mag wel.-->
<!--</p>-->
<!--<p>-->
<!--    Er geldt wel een verplichting als je een herinvesteringsreserve wilt afboeken op de aanschaffingskosten van een-->
<!--    bedrijfsmiddel waarop de vennootschap niet afschrijft of waarop de vennootschap in meer dan 10 jaar afschrijft. Je-->
<!--    mag op deze investering alleen een herinvesteringsreserve afboeken die is ontstaan door de vervreemding van een-->
<!--    bedrijfsmiddel met dezelfde economische functie als het aangeschafte bedrijfsmiddel. Je mag dus niet de-->
<!--    gereserveerde-->
<!--    boekwinst op bijvoorbeeld een computer afboeken op de aanschaffingskosten van een pand.-->
<!--</p>-->

<!--<b>Vrijval herinvesteringsreserve</b>-->
<!--<p>je moet de herinvesteringsreserve of het restant daarvan toevoegen aan de winst op het moment dat de vennootschap-->
<!--    niet meer van plan-->
<!--    is om te herinvesteren. Zo vindt alsnog belastingheffing over de boekwinst plaats.-->
<!--    <br/>-->
<!--    De reserve of het restant daarvan valt ook vrij als er 3 jaar verstreken zijn na het boekjaar waarin de vennootschap-->
<!--    de reserve-->
<!--    heeft gevormd, en de vennootschap nog niet een herinvestering hebt gedaan. Deze termijn van 3 jaar kan alleen worden-->
<!--    verlengd-->
<!--    als:-->
<!--</p>-->
<!--<ul>-->
<!--    <li>voor de herinvestering een langer tijdvak vereist is, in verband met de aard van de bedrijfsmiddelen die u wilt-->
<!--        aanschaffen of voortbrengen.-->
<!--    </li>-->
<!--    <li>de herinvestering door bijzondere omstandigheden is vertraagd. Voorwaarde hierbij is dat de uitvoering van de-->
<!--        aanschaf of voortbrenging al is gestart.-->
<!--    </li>-->
<!--</ul>-->

<!--<br/>-->
<!--<b>OVERIGE RESERVES</b><br/>-->
<!--Hieronder vallen o.a. de:-->
<!--<ul>-->
<!--    <li>Bestedingsreserve.-->
<!--    </li>-->
<!--    <li>Opwaarderingsreserve.-->
<!--    </li>-->
<!--</ul>-->

<!--<b>Bestedingsreserve</b>-->
<!--<p>Culturele instellingen en lichamen zonder aandeelhouders, of deelgerechtigden die een sociaal belang behartigen en-->
<!--    die hun winst hoofdzakelijk behalen met behulp van vrijwilligers kunnen voor bepaalde kosten een bestedingsreserve-->
<!--    vormen.</p>-->
<!--<p>Het gaat om kosten die in het boekjaar of in de volgende 5 jaar bestaan uit:</p>-->
<!--<ul>-->
<!--    <li>uitgaven voor de aanschaf, voortbrenging of verbetering van bedrijfsmiddelen, met uitzondering van onroerende-->
<!--        zaken die bestemd zijn om (in)direct hoofdzakelijk aan derden ter beschikking te stellen.-->
<!--    </li>-->
<!--    <li>uitgaven voor projecten.</li>-->
<!--</ul>-->
<!--<p>Je kunt de bestedingsreserve vormen voor zover de ondernemingsactiviteiten in de lijn liggen van het belang dat bij-->
<!--    het lichaam op de voorgrond staat. Ook kun je een bestedingsreserve vormen als er sprake is van inzamelen (zonder-->
<!--    dat daar een tegenprestatie tegenover staat) en vervolgens verkopen van gebruikte goederen. De winst moet dan wel-->
<!--    worden gebruikt voor uitgaven in het belang dat bij het lichaam op de voorgrond staat.</p>-->

<!--<p>Een gevormde bestedingsreserve moet je uiterlijk in het 5e jaar na het jaar waarin deze is ontstaan, opnemen in de-->
<!--    winst. Van deze regel kun je alleen afwijken als:-->
<!--</p>-->
<!--<ul style="list-style: disc;">-->
<!--    <li>uit de aard van het bedrijfsmiddel of het project voortvloeit dat een langer tijdvak is vereist.</li>-->
<!--    <li>de uitvoering is vertraagd door bijzondere omstandigheden, maar de investering in het bedrijfsmiddel of de-->
<!--        uitvoering van het project wel begonnen is.-->
<!--    </li>-->
<!--</ul>-->

<!--<br/>-->
<!--<b>Opwaarderingsreserve</b>-->
<!--<p>Op grond van artikel 13ba Vpb leidt een omzetting in kapitaal, een kwijtschelding of het gaan functioneren als eigen-->
<!--    vermogen van een afgewaardeerde schuldvordering op een deelneming tot een bijtelling bij de winst. Die bijtelling is-->
<!--    gelijk aan het bedrag van de afwaardering. Datzelfde bedrag mag echter tegelijkertijd ten laste van de winst worden-->
<!--    toegevoegd aan een opwaarderingsreserve.</p>-->
<!--<p>Het gaat hierbij om situaties waarin de schuldenaar de schuldvordering geheel of gedeeltelijk voldoet door:</p>-->
<!--<ul>-->
<!--    <li>uitgifte van aandelen, winstbewijzen, lidmaatschapsrechten (in het geval van een coöperatie)</li>-->
<!--    <li>bewijzen van deelgerechtigdheid (bijvoorbeeld in het geval van een fonds voor gemene rekening)</li>-->
<!--</ul>-->

<!--<p>Ook gaat het om situaties waarbij de schuld is gaan functioneren als eigen vermogen zonder dat daarvoor aandelen zijn-->
<!--    uitgegeven.Van omzetting is ook sprake bij het geheel of gedeeltelijk prijsgeven van de vordering terwijl dit-->
<!--    prijsgeven is-->
<!--    ingegeven door aandeelhoudersmotieven.</p>-->
<!--<p>De opwaarderingsreserve wordt jaarlijks aan de winst toegevoegd voor zover het verschil tussen de actuele waarde in-->
<!--    het economische verkeer van de deelneming en de waarde in het economische verkeer van de deelneming op het moment-->
<!--    van de omzetting, kwijtschelding of het gaan functioneren als eigen vermogen uitgaat boven het bedrag waarmee de-->
<!--    opwaarderingsreserve sinds de omzetting, kwijtschelding of het gaan functioneren als eigen vermogen, is-->
<!--    afgenomen.</p>-->
<!--<p>In bepaalde situaties wordt de gehele (resterende) opwaarderingsreserve ineens aan de winst toegevoegd. Dat-->
<!--    gebeurt:</p>-->
<!--<ul>-->
<!--    <li>als (een gedeelte van) de onderneming van de schuldenaar wordt vervreemd aan de vennootschap of een met de-->
<!--        vennootschap verbonden lichaam of-->
<!--        natuurlijke persoon.-->
<!--    </li>-->
<!--    <li>als (een gedeelte van) de deelneming in de schuldenaar wordt vervreemd aan een met de vennootschap verbonden-->
<!--        natuurlijke-->
<!--        persoon.-->
<!--    </li>-->
<!--    <li>als de schuldenaar als dochtermaatschappij deel gaat uitmaken van een fiscale eenheid met de vennootschap.</li>-->
<!--</ul>-->
<!--<p>De opwaarderingsreserve valt ook geheel vrij als de vennootschap op enig moment geen deelneming meer bezit in de-->
<!--    schuldenaar,-->
<!--    anders dan door de hiervoor genoemde situaties. Deze vrijval hoeft de vennootschap echter niet aan de winst toe te-->
<!--    voegen. Het-->
<!--    gaat hier bijvoorbeeld om het geval waarin de vennootschap de deelneming in de schuldenaar aan een derde verkoopt.-->
<!--</p>-->

<!--<br/>-->
<!--<b>GARANTIEVOORZIENINGEN</b><br/>-->
<!--<p>-->
<!--    Als op de balansdatum een reële kans bestaat dat de onderneming zal worden aangesproken voor een verleende garantie,-->
<!--    dan mag de vennootschap daarvoor een voorziening opvoeren. De grootte van de voorziening kun je meestal bepalen aan-->
<!--    de hand van de bedragen waarvoor de onderneming in het verleden is aangesproken.-->
<!--</p>-->

<!--<br/>-->
<!--<b>Oudedagsvoorzieningen</b><br/>-->
<!--<p>Hieronder vallen voorzieningen als een:</p>-->
<!--<ul>-->
<!--    <li>stamrechtvoorzien</li>-->
<!--    <li>pijfrentevoorziening</li>-->
<!--    <li>pensioenvoorziening.</li>-->
<!--</ul>-->
<!--<p>Ga bij het berekenen van de hoogte van de voorziening uit van algemeen aanvaarde actuariële grondslagen en van een-->
<!--    rekenrente van ten minste 4%.-->
<!--</p>-->

<!--<b>Stamrechtvoorziening</b>-->
<!--<p>-->
<!--    Een stamrecht is een recht op periodieke uitkeringen. Dit recht op een maandelijkse uitkering komt voort uit de-->
<!--    ontvangst van een ontslagvergoeding of een gouden handdruk. Ga bij het berekenen van de-->
<!--    hoogte van de voorziening uit van de stamrechtovereenkomst.-->
<!--</p>-->
<!--<br/>-->

<!--<b>Lijfrentevoorziening</b>-->
<!--<p>Een (stakings)lijrentevoorziening vindt vaak haar oorsprong vindt in/bij de inbreng van een eenmanszaak, vennootschap-->
<!--    onder firma en/of maatschap in een BV. Voor de bij deze inbreng gerealiseerde stakingswinst is bij de voortzettende-->
<!--    BV een stakingslijfrente bedongen. Nadat deze voortzettende BV haar activiteiten heeft gestaakt, is er een BV-->
<!--    overgebleven waarvan de activiteiten louter bestaan uit het beheren van vermogen en het uitvoeren van de-->
<!--    lijfrenteverplichting.-->
<!--</p>-->
<!--<p>Ga bij het berekenen van de hoogte van de voorziening uit van algemeen aanvaarde actuariële grondslagen en van een-->
<!--    rekenrente van ten minste 4%.</p>-->
<!--<br/>-->

<!--<b>Pensioenvoorziening</b>-->
<!--<p>Het gaat om de situatie waarbij de vennootschap aan het personeel een pensioentoezegging hebt gedaan en de-->
<!--    verplichting hiervoor in-->
<!--    eigen beheer houdt.</p>-->
<!--<p>Sinds 1 juli 2017 kan de vennootschao niet langer in eigen beheer pensioen opbouwen. Dus ook niet meer voor de-->
<!--    directeur-aandeelhouder. JeEen (stakings) lijfrente BV is een BV die haar oorsprong vindt in/bij de inbreng van een-->
<!--    eenmanszaak, vennootschap onder firma en/of maatschap. Voor de bij deze inbreng gerealiseerde stakingswinst is bij-->
<!--    de voortzettende BV een stakingslijfrente bedongen. Nadat deze voortzettende BV haar activiteiten heeft gestaakt, is-->
<!--    er een BV overgebleven waarvan de activiteiten louter bestaan uit het beheren van vermogen en het uitvoeren van de-->
<!--    lijfrenteverplichting. Je kunt ook geen bedragen meer toevoegen aan pensioenvoorzieningen die de vennootschap eerder-->
<!--    in eigen beheer hebt gevormd.-->
<!--</p>-->

<!--<br/>-->
<!--<b>Overige voorzieningen</b>-->
<!--<p>Onder 'Overige voorzieningen' valt bijvoorbeeld de milieuvoorziening. Als een onderneming is veroordeeld voor bodem- -->
<!--    of milieuverontreiniging, dan is er sprake van een juridisch afdwingbare verplichting. Deze verplichting moet je-->
<!--    volgens goed koopmansgebruik waarderen. Het kan ook zijn dat de vennootschap een voorziening moet vormen voor-->
<!--    sanering van milieuverontreiniging. Dit is bijvoorbeeld het geval als er een procedure is aangespannen waarin de-->
<!--    vennootschap aansprakelijk bent gesteld voor de kosten van bodemsanering.-->
<!--</p>-->

<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
              Gestort en opgevraagd kapitaal
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Het gestort kapitaal is het bedrag dat de aandeelhouders voor hun aandelen hebben betaald aan de BV
                    of NV. Dit bedrag wordt overgemaakt op de bankrekening van de vennootschap. Het gestort kapitaal is
                    dus eigenlijk het vermogen dat daadwerkelijk in de BV of NV aanwezig is en tot haar beschikking
                    heeft.
                    <br/><br/>
                    Als de storting op aandelen heeft plaatsgevonden in het kader van een geruisloze omzetting, geldt
                    inprincipe de boekwaarde van het vermogen van de ingebrachte onderneming, na aftrek van de fiscale
                    reserves, als gestort kapitaal. In dat geval stelt u in de fiscale vermogensopstelling het bedrag
                    van het gestorte kapitaal, samen met het eventuele agio, gelijk aan de fiscale boekwaarde van de
                    overgedragen onderneming op het overgangstijdstip.
                    <br/><br/>Voor een rechtspersoon die geen nv of bv is, vermeld je het equivalent voor het begrip
                    kapitaal dat voor die rechtspersoon geldt.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Informeel kapitaal
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Van informeel kapitaal kan sprake zijn als de vennootschap door de aandeelhouder(s) is bevoordeeld,
                    zonder dat een storting op aandelen heeft plaatsgevonden. De waarde van deze bevoordeling geef je
                    hier aan.
                </p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    De aandeelhouder verkoopt onroerend goed aan de vennootschap voor € 500.000, terwijl de werkelijke
                    waarde € 800.000 is. De vennootschap wordt bevoordeeld voor € 300.000.
                </div>
                <br/>
                <p>
                    Als informele kapitaalstorting wordt ook aangemerkt de kapitaalstorting voor toegekende
                    werknemersopties.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Agioreserve
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Agio is het bedrag dat bij uitgifte van aandelen wordt gestort boven het nominale bedrag.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingT4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Winstreserves
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="headingT4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Winstreserves zijn:
                </p>
                <ul>
                    <li>Winsten die in het verleden zijn behaald, maar die niet zijn uitgekeerd.</li>
                    <li>Verliezen die in het verleden zijn behaald.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Kostenegalisatiereserve
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Je mag een zogenoemde egalisatiereserve vormen voor kosten en lasten van de bedrijfsuitoefening in
                    dit boekjaar, die pas in de toekomst tot een piek in de uitgaven leiden. Het bekendste voorbeeld
                    hiervan zijn onderhoudskosten aan gebouwen en schepen, waarbij het daadwerkelijke onderhoud
                    bijvoorbeeld eens in de 10 jaar gebeurt.<br/>Een belangrijke voorwaarde is dat het gaat om
                    toekomstige uitgaven wegens kosten, en niet om
                    toekomstige aanschaf of verbetering van bedrijfsmiddelen. De uitgaven voor aanschaf of verbetering
                    van een bedrijfsmiddel breng je in mindering op de winst door de jaarlijkse afschrijving op dit
                    bedrijfsmiddel.
                </p>

                <p>De overige voorwaarden voor het vormen van de egalisatiereserve zijn in de jurisprudentie ontwikkeld.
                    Deze zijn:</p>
                <ul>
                    <li>De kosten worden verdeeld in de toekomst uitgegeven.</li>
                    <li>De kosten zijn noodzakelijk geworden door de ondernemingsuitoefening in het jaar van dotatie
                        (toevoeging).
                    </li>
                    <li>De kosten die in een bepaald jaar zijn opgeroepen, leiden in een komend jaar tot een piek in de
                        uitgaven.
                    </li>
                    <li>Er is een redelijke mate van zekerheid dat de uitgaven zich zullen voordoen.</li>
                </ul>

                <b>Te reserveren bedrag</b>
                <p>Het bedrag dat je mag reserveren, hangt af van de verwachting over de hoogte van de toekomstige
                    kosten en het tijdstip waarop u de kosten maakt. Je moet dus een redelijke schatting maken. Blijkt
                    achteraf dat de schatting te hoog is uitgevallen? Dan moet je het overschot in de winst opnemen. De
                    jaarlijkse toevoeging hoeft niet altijd gelijk te zijn. Deze kan bijvoorbeeld wijzigen als de kosten
                    stijgen of de periode verandert. De wijzigingen geef je op bij 'Wijzigingen in toelaatbare
                    reserves'.
                    <br/>Je mag een aparte reserve vormen per bedrijfsmiddel. Het is ook mogelijk dat je een reserve
                    vormt per object, bijvoorbeeld voor onderhoud dat eens per 10 jaar en onderhoud dat eens per 15 jaar
                    moet worden verricht. In de balans vermeld je de boekwaarde van het totaal van de afzonderlijke
                    egalisatiereserves.</p>

                <b>Afname van de reserve</b>
                <p>In het jaar waarin de vennootschap de kosten (van bijvoorbeeld het onderhoud) maakt, boek je de
                    kosten af op de
                    reserve. Als de reserve hoger is dan de gemaakte kosten, dan moet je het restant van de reserve
                    opnemen in de winst. Zijn de kosten hoger dan de gevormde reserve, dan trek je de hogere kosten in 1
                    keer af van de winst.<br/>Je moet de reserve ook in de winst opnemen als het doel waarvoor de
                    reserve ooit is gevormd, is
                    komen te vervallen. Dit is bijvoorbeeld het geval als de vennootschap het bedrijfsmiddel verkoopt
                    waarvoor ze de reserve had gevormd, of als het bedrijfsmiddel verloren gaat.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Herinvesteringsreserve
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div>
                <p>Je mag de boekwinst op bedrijfsmiddelen opnemen in de herinvesteringsreserve. Je hoeft dan niet
                    direct belasting te betalen over de boekwinst. Voorwaarde is dat de vennootschap op de balansdatum
                    een voornemen hebt om te herinvesteren in een bedrijfsmiddel.
                    <br/>En het moet gaan om bedrijfsmiddelen die de vennootschap heeft ‘vervreemd’. Daarvan is sprake
                    als je een bedrijfsmiddel verkoopt. Maar ook als ke een bedrijfsmiddel verliest of als het
                    beschadigd raakt.
                </p>

                <b>Bij verkoop van een bedrijfsmiddel</b>
                <p>De boekwinst op het verkochte bedrijfsmiddel neemt je niet op in de fiscale winst, maar voeg je toe
                    aan de herinvesteringsreserve. Hiermee voorkom je dat er direct belasting wordt geheven over die
                    boekwinst.
                </p>

                <b>Bij verlies of beschadiging van een bedrijfsmiddel</b>
                <p>Ontvang de vennootschap een vergoeding voor het verlies of de beschadiging? Dan komt die als
                    opbrengst in de
                    boekhouding te staan. Het verschil tussen deze opbrengst en de boekwaarde van het bedrijfsmiddel is
                    de boekwinst. Die mag je opnemen in de herinvesteringsreserve.
                </p>

                <b>Afboeken herinvesteringsreserve</b>
                <p>Gaat de vennootschap herinvesteren? Boek dan de gereserveerde boekwinst als een 1e afboeking op de
                    aanschafprijs van het aangeschafte bedrijfsmiddel. Door de afboeking mag de boekwaarde van het
                    nieuwe bedrijfsmiddel niet lager worden dan de boekwaarde van het vervreemde bedrijfsmiddel op het
                    moment van vervreemding. Het restant van de reserve kun je afboeken op een eventuele volgende
                    investering die de vennootschap binnen de herinvesteringstermijn doet.
                    <br/>
                    De afboeking verlaagt de afschrijvingsbasis van het nieuwe bedrijfsmiddel.
                </p>
                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld</u></p>
                    <p>De hoogte van de herinvesteringsreserve is € 5.000. De vennootschap investeert voor € 30.000 in
                        een nieuw bedrijfsmiddel. De restwaarde van dit bedrijfsmiddel is € 10.000. De afschrijving is
                        20% per jaar.
                        <br/>De afschrijving per jaar bedraagt dan:</p>
                    <ul>
                        <li>zonder 1e afboeking op de aanschafprijs: 20% van (€ 30.000 - € 10.000) = € 4.000.</li>
                        <li>met 1e afboeking op de aanschafprijs: 20% van (€ 30.000 - € 5.000 - € 10.000) = € 3.000.
                        </li>
                    </ul>
                </div>

                <p>Op het verplicht afboeken van de herinvesteringsreserve bestaat een uitzondering. De
                    herinvesteringsreserve die ontstaat door de vervreemding van een bedrijfsmiddel waarop de
                    vennootschap niet afschrijft of waarop de vennootschap in meer dan 10 jaar afschrijft, hoef je
                    namelijk pas af te boeken als de vennootschap een bedrijfsmiddel aanschaft met dezelfde economische
                    functie als het vervreemde bedrijfsmiddel. Je bent bijvoorbeeld niet verplicht de
                    herinvesteringsreserve van een verkocht bedrijfspand af te boeken op de aanschaffingskosten van een
                    computer. Maar het mag wel.
                </p>
                <p>
                    Er geldt wel een verplichting als je een herinvesteringsreserve wilt afboeken op de
                    aanschaffingskosten van een bedrijfsmiddel waarop de vennootschap niet afschrijft of waarop de
                    vennootschap in meer dan 10 jaar afschrijft. Je mag op deze investering alleen een
                    herinvesteringsreserve afboeken die is ontstaan door de vervreemding van een bedrijfsmiddel met
                    dezelfde economische functie als het aangeschafte bedrijfsmiddel. Je mag dus niet de gereserveerde
                    boekwinst op bijvoorbeeld een computer afboeken op de aanschaffingskosten van een pand.
                </p>

                <b>Vrijval herinvesteringsreserve</b>
                <p>je moet de herinvesteringsreserve of het restant daarvan toevoegen aan de winst op het moment dat de
                    vennootschap niet meer van plan is om te herinvesteren. Zo vindt alsnog belastingheffing over de
                    boekwinst plaats.
                    <br/>
                    De reserve of het restant daarvan valt ook vrij als er 3 jaar verstreken zijn na het boekjaar waarin
                    de vennootschap de reserve heeft gevormd, en de vennootschap nog niet een herinvestering hebt
                    gedaan. Deze termijn van 3 jaar kan alleen worden verlengd als:
                </p>
                <ul>
                    <li>voor de herinvestering een langer tijdvak vereist is, in verband met de aard van de
                        bedrijfsmiddelen die u wilt aanschaffen of voortbrengen.
                    </li>
                    <li>de herinvestering door bijzondere omstandigheden is vertraagd. Voorwaarde hierbij is dat de
                        uitvoering van de aanschaf of voortbrenging al is gestart.
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Overige reserves
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Hieronder vallen o.a. de:
                <ul>
                    <li>Bestedingsreserve.
                    </li>
                    <li>Opwaarderingsreserve.
                    </li>
                </ul>

                <b>Bestedingsreserve</b>
                <p>Culturele instellingen en lichamen zonder aandeelhouders, of deelgerechtigden die een sociaal belang
                    behartigen en die hun winst hoofdzakelijk behalen met behulp van vrijwilligers kunnen voor bepaalde
                    kosten een bestedingsreserve vormen.</p>
                <p>Het gaat om kosten die in het boekjaar of in de volgende 5 jaar bestaan uit:</p>
                <ul>
                    <li>uitgaven voor de aanschaf, voortbrenging of verbetering van bedrijfsmiddelen, met uitzondering
                        van onroerende zaken die bestemd zijn om (in)direct hoofdzakelijk aan derden ter beschikking te
                        stellen.
                    </li>
                    <li>uitgaven voor projecten.</li>
                </ul>
                <p>Je kunt de bestedingsreserve vormen voor zover de ondernemingsactiviteiten in de lijn liggen van het
                    belang dat bij het lichaam op de voorgrond staat. Ook kun je een bestedingsreserve vormen als er
                    sprake is van inzamelen (zonder
                    dat daar een tegenprestatie tegenover staat) en vervolgens verkopen van gebruikte goederen. De winst
                    moet dan wel worden gebruikt voor uitgaven in het belang dat bij het lichaam op de voorgrond
                    staat.</p>

                <p>Een gevormde bestedingsreserve moet je uiterlijk in het 5e jaar na het jaar waarin deze is ontstaan,
                    opnemen in de winst. Van deze regel kun je alleen afwijken als:
                </p>
                <ul style="list-style: disc;">
                    <li>uit de aard van het bedrijfsmiddel of het project voortvloeit dat een langer tijdvak is
                        vereist.
                    </li>
                    <li>de uitvoering is vertraagd door bijzondere omstandigheden, maar de investering in het
                        bedrijfsmiddel of de uitvoering van het project wel begonnen is.
                    </li>
                </ul>

                <b>Opwaarderingsreserve</b>
                <p>Op grond van artikel 13ba Vpb leidt een omzetting in kapitaal, een kwijtschelding of het gaan
                    functioneren als eigen vermogen van een afgewaardeerde schuldvordering op een deelneming tot een
                    bijtelling bij de winst. Die bijtelling is gelijk aan het bedrag van de afwaardering. Datzelfde
                    bedrag mag echter tegelijkertijd ten laste van de winst worden toegevoegd aan een
                    opwaarderingsreserve.</p>
                <p>Het gaat hierbij om situaties waarin de schuldenaar de schuldvordering geheel of gedeeltelijk voldoet
                    door:</p>
                <ul>
                    <li>uitgifte van aandelen, winstbewijzen, lidmaatschapsrechten (in het geval van een coöperatie)
                    </li>
                    <li>bewijzen van deelgerechtigdheid (bijvoorbeeld in het geval van een fonds voor gemene rekening)
                    </li>
                </ul>

                <p>Ook gaat het om situaties waarbij de schuld is gaan functioneren als eigen vermogen zonder dat
                    daarvoor aandelen zijn
                    uitgegeven.Van omzetting is ook sprake bij het geheel of gedeeltelijk prijsgeven van de vordering
                    terwijl dit prijsgeven is ingegeven door aandeelhoudersmotieven.</p>
                <p>De opwaarderingsreserve wordt jaarlijks aan de winst toegevoegd voor zover het verschil tussen de
                    actuele waarde in het economische verkeer van de deelneming en de waarde in het economische verkeer
                    van de deelneming op het moment van de omzetting, kwijtschelding of het gaan functioneren als eigen
                    vermogen uitgaat boven het bedrag waarmee de opwaarderingsreserve sinds de omzetting, kwijtschelding
                    of het gaan functioneren als eigen vermogen, is afgenomen.</p>
                <p>In bepaalde situaties wordt de gehele (resterende) opwaarderingsreserve ineens aan de winst
                    toegevoegd. Dat
                    gebeurt:</p>
                <ul>
                    <li>als (een gedeelte van) de onderneming van de schuldenaar wordt vervreemd aan de vennootschap of
                        een met de vennootschap verbonden lichaam of natuurlijke persoon.
                    </li>
                    <li>als (een gedeelte van) de deelneming in de schuldenaar wordt vervreemd aan een met de
                        vennootschap verbonden natuurlijke persoon.
                    </li>
                    <li>als de schuldenaar als dochtermaatschappij deel gaat uitmaken van een fiscale eenheid met de
                        vennootschap.
                    </li>
                </ul>
                <p>De opwaarderingsreserve valt ook geheel vrij als de vennootschap op enig moment geen deelneming meer
                    bezit in de schuldenaar, anders dan door de hiervoor genoemde situaties. Deze vrijval hoeft de
                    vennootschap echter niet aan de winst toe te voegen. Het gaat hier bijvoorbeeld om het geval waarin
                    de vennootschap de deelneming in de schuldenaar aan een derde verkoopt.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Garantievoorziening
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Als op de balansdatum een reële kans bestaat dat de onderneming zal worden aangesproken voor een
                    verleende garantie,
                    dan mag de vennootschap daarvoor een voorziening opvoeren. De grootte van de voorziening kun je
                    meestal bepalen aan
                    de hand van de bedragen waarvoor de onderneming in het verleden is aangesproken.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Oudedagsvoorzieningen
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Hieronder vallen voorzieningen als een:</p>
                <ul>
                    <li>stamrechtvoorzien</li>
                    <li>pijfrentevoorziening</li>
                    <li>pensioenvoorziening.</li>
                </ul>
                <p>Ga bij het berekenen van de hoogte van de voorziening uit van algemeen aanvaarde actuariële
                    grondslagen en van een
                    rekenrente van ten minste 4%.
                </p>
                <b>Stamrechtvoorziening</b>
                <p>
                    Een stamrecht is een recht op periodieke uitkeringen. Dit recht op een maandelijkse uitkering komt
                    voort uit de
                    ontvangst van een ontslagvergoeding of een gouden handdruk. Ga bij het berekenen van de
                    hoogte van de voorziening uit van de stamrechtovereenkomst.
                </p>
                <br/>

                <b>Lijfrentevoorziening</b>
                <p>Een (stakings)lijrentevoorziening vindt vaak haar oorsprong vindt in/bij de inbreng van een
                    eenmanszaak, vennootschap
                    onder firma en/of maatschap in een BV. Voor de bij deze inbreng gerealiseerde stakingswinst is bij
                    de voortzettende
                    BV een stakingslijfrente bedongen. Nadat deze voortzettende BV haar activiteiten heeft gestaakt, is
                    er een BV
                    overgebleven waarvan de activiteiten louter bestaan uit het beheren van vermogen en het uitvoeren
                    van de
                    lijfrenteverplichting.
                </p>
                <p>Ga bij het berekenen van de hoogte van de voorziening uit van algemeen aanvaarde actuariële
                    grondslagen en van een
                    rekenrente van ten minste 4%.</p>
                <br/>

                <b>Pensioenvoorziening</b>
                <p>Het gaat om de situatie waarbij de vennootschap aan het personeel een pensioentoezegging hebt gedaan
                    en de
                    verplichting hiervoor in
                    eigen beheer houdt.</p>
                <p>Sinds 1 juli 2017 kan de vennootschao niet langer in eigen beheer pensioen opbouwen. Dus ook niet
                    meer voor de
                    directeur-aandeelhouder. JeEen (stakings) lijfrente BV is een BV die haar oorsprong vindt in/bij de
                    inbreng van een
                    eenmanszaak, vennootschap onder firma en/of maatschap. Voor de bij deze inbreng gerealiseerde
                    stakingswinst is bij
                    de voortzettende BV een stakingslijfrente bedongen. Nadat deze voortzettende BV haar activiteiten
                    heeft gestaakt, is
                    er een BV overgebleven waarvan de activiteiten louter bestaan uit het beheren van vermogen en het
                    uitvoeren van de
                    lijfrenteverplichting. Je kunt ook geen bedragen meer toevoegen aan pensioenvoorzieningen die de
                    vennootschap eerder
                    in eigen beheer hebt gevormd.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Overige voorzieningen
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Onder 'Overige voorzieningen' valt bijvoorbeeld de milieuvoorziening. Als een onderneming is
                    veroordeeld voor bodem-
                    of milieuverontreiniging, dan is er sprake van een juridisch afdwingbare verplichting. Deze
                    verplichting moet je
                    volgens goed koopmansgebruik waarderen. Het kan ook zijn dat de vennootschap een voorziening moet
                    vormen voor
                    sanering van milieuverontreiniging. Dit is bijvoorbeeld het geval als er een procedure is
                    aangespannen waarin de
                    vennootschap aansprakelijk bent gesteld voor de kosten van bodemsanering.
                </p>
            </div>
        </div>
    </div>
</div>
